import React from 'react';
export function Hero() {
  return <section className="relative bg-gradient-to-r from-riskeys-dark to-riskeys-blue-dark overflow-hidden" data-id="element-203">
      {/* Background pattern */}
      <div className="absolute inset-0 z-0 opacity-10" data-id="element-204">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-205">
          <defs data-id="element-206">
            <pattern id="grid" width="8" height="8" patternUnits="userSpaceOnUse" data-id="element-207">
              <path d="M 8 0 L 0 0 0 8" fill="none" stroke="white" strokeWidth="0.5" data-id="element-208" />
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#grid)" data-id="element-209" />
        </svg>
      </div>
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-40" data-id="element-210">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-211">
          <div className="md:w-1/2 mb-16 md:mb-0" data-id="element-212">
            <div className="inline-flex items-center bg-white/10 backdrop-blur-md rounded-full pl-1 pr-4 py-1 mb-6" data-id="element-213">
              <span className="bg-riskeys-accent-default text-white text-xs font-semibold px-3 py-1 rounded-full mr-2" data-id="element-214">
                CABINET INDÉPENDANT
              </span>
              <span className="text-white text-sm" data-id="element-215">
                Conseil & audit en assurance
              </span>
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-216">
              <span className="block" data-id="element-217">Optimisez vos</span>
              <span className="text-riskeys-accent-light" data-id="element-218">assurances</span>
            </h1>
            <h2 className="text-xl md:text-2xl font-medium text-white/90 mb-10 max-w-xl leading-relaxed" data-id="element-219">
              Conseil & audit en assurance – L'expertise qui fait la différence
              pour les{' '}
              <span className="text-riskeys-accent-light" data-id="element-220">
                décideurs exigeants
              </span>
              .
            </h2>
            <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-221">
              <a href="#contact" className="inline-flex items-center justify-center bg-riskeys-accent-default hover:bg-riskeys-accent-dark text-white font-semibold py-4 px-8 rounded-md transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-222">
                Demander un audit
              </a>
              <a href="#domaines-interventions" className="inline-flex items-center justify-center bg-transparent hover:bg-white/10 text-white font-semibold py-4 px-8 rounded-md border border-white/30 transition-all duration-300" data-id="element-223">
                Découvrir nos expertises
              </a>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-8 space-y-4 sm:space-y-0 text-white" data-id="element-224">
              <span className="flex items-center" data-id="element-225">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-riskeys-accent-light" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-226">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-227" />
                </svg>
                <span className="text-white/80" data-id="element-228">100% indépendant</span>
              </span>
              <span className="flex items-center" data-id="element-229">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-riskeys-accent-light" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-230">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-231" />
                </svg>
                <span className="text-white/80" data-id="element-232">Paiement au résultat</span>
              </span>
            </div>
          </div>
          <div className="md:w-2/5" data-id="element-233">
            <div className="bg-white/95 backdrop-blur-md rounded-lg shadow-premium p-8 md:p-10 border border-white/20" data-id="element-234">
              <div className="bg-riskeys-blue-default text-white text-sm font-semibold px-4 py-2 rounded-md inline-block -mt-14 mb-6 shadow-md" data-id="element-235">
                Optimisez vos contrats d'assurance
              </div>
              <h3 className="text-2xl font-bold text-riskeys-dark mb-8" data-id="element-236">
                Jusqu'à <span className="text-riskeys-accent-default" data-id="element-237">30%</span>{' '}
                d'économies
              </h3>
              <ul className="space-y-6" data-id="element-238">
                <li className="flex" data-id="element-239">
                  <div className="flex-shrink-0 h-8 w-8 rounded-md bg-riskeys-accent-light/20 flex items-center justify-center mt-0.5" data-id="element-240">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-241">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-242" />
                    </svg>
                  </div>
                  <p className="ml-4 text-gray-600" data-id="element-243">
                    <strong className="text-riskeys-dark font-semibold" data-id="element-244">
                      Tiers de confiance
                    </strong>
                    , pas un courtier
                  </p>
                </li>
                <li className="flex" data-id="element-245">
                  <div className="flex-shrink-0 h-8 w-8 rounded-md bg-riskeys-accent-light/20 flex items-center justify-center mt-0.5" data-id="element-246">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-247">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-248" />
                    </svg>
                  </div>
                  <p className="ml-4 text-gray-600" data-id="element-249">
                    <strong className="text-riskeys-dark font-semibold" data-id="element-250">
                      +10 ans d'expertise
                    </strong>{' '}
                    en conseil et audit en assurance
                  </p>
                </li>
                <li className="flex" data-id="element-251">
                  <div className="flex-shrink-0 h-8 w-8 rounded-md bg-riskeys-accent-light/20 flex items-center justify-center mt-0.5" data-id="element-252">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-253">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-254" />
                    </svg>
                  </div>
                  <p className="ml-4 text-gray-600" data-id="element-255">
                    <strong className="text-riskeys-dark font-semibold" data-id="element-256">
                      Paiement uniquement
                    </strong>{' '}
                    sur les économies réalisées
                  </p>
                </li>
                <li className="flex" data-id="element-257">
                  <div className="flex-shrink-0 h-8 w-8 rounded-md bg-riskeys-accent-light/20 flex items-center justify-center mt-0.5" data-id="element-258">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-riskeys-accent-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-259">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-260" />
                    </svg>
                  </div>
                  <p className="ml-4 text-gray-600" data-id="element-261">
                    <strong className="text-riskeys-dark font-semibold" data-id="element-262">
                      Approche personnalisée
                    </strong>{' '}
                    adaptée à votre secteur
                  </p>
                </li>
              </ul>
              <div className="mt-10" data-id="element-263">
                <a href="#contact" className="block w-full bg-riskeys-accent-default hover:bg-riskeys-accent-dark text-white text-center font-semibold py-4 px-6 rounded-md transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-264">
                  Demander un audit gratuit
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Wave divider */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-265">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" className="w-full h-auto fill-white" data-id="element-266">
          <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,42.7C1120,32,1280,32,1440,42.7L1440,100L0,100Z" data-id="element-267"></path>
        </svg>
      </div>
    </section>;
}